export const filterConditionExactIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.571 9V7.476h15.237V9zm0 4.571v-1.524h15.237v1.524z"/></svg>`,
  name: 'filter-condition-exact',
};
